import { FC, HTMLAttributes, useEffect, useState } from "react";
import { useStyles } from "./Languages.style";
import { Typography } from "../../components/core/Typography/Typography";
import { TypographyVariant } from "../../constants/typography";
import AppBar from "../../components/common/AppBar/AppBar";
import { Icon } from "../../components/core/Icon/Icon";
import { Radio } from "../../components/core/Radio/Radio";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { meGQL, updateUserGQL } from "../../graphql";
import { useAppDispatch } from "../../components/hooks";
import { showSnackbar } from "../../store/slices/alert";
import { changeLanguage } from "i18next";
import { useTranslation } from "react-i18next";
import { HistoryGaming } from "../../models/historyGaming";
import { useNavigate } from "react-router-dom";
import { getLanguages } from "../../models/settings";

export const Languages: FC<HTMLAttributes<HTMLDivElement>> = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { languages } = getLanguages();

  const { data: dataMe } = useQuery(meGQL);
  const [fetchUser] = useLazyQuery(meGQL);
  const [updateUserMutation] = useMutation(updateUserGQL);

  const [selectedLanguage, setSelectedLanguage] = useState<string | undefined>(
    dataMe?.me?.language,
  );

  const onUpdateUser = async (language: string) => {
    try {
      setSelectedLanguage(language);
      await updateUserMutation({
        variables: { input: { language: language } },
      });
      await changeLanguage(language);
      fetchUser({ fetchPolicy: "network-only" });
      dispatch(showSnackbar(t("common_Language update successfully!")));
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <div className={classes.root}>
      <AppBar
        leftItems={
          <Icon
            name="icon-bold-arrow-left-3"
            onClick={() => HistoryGaming.back(navigate)}
          />
        }
        centerItems={
          <Typography variant={TypographyVariant.BodyB4Medium}>
            {t("settings_Languages")}
          </Typography>
        }
      />
      <div className={classes.container}>
        <Typography variant={TypographyVariant.HeadingH5Bold}>
          {t("settings_Choose your preferred language")}
        </Typography>
        {languages.map((language) => (
          <div
            className={classes.languageItem}
            onClick={() => onUpdateUser(language)}
          >
            <Typography variant={TypographyVariant.BodyB5Regular}>
              {t(`settings_${language}`)}
            </Typography>
            <Radio checked={selectedLanguage === language} />
          </div>
        ))}
      </div>
    </div>
  );
};
